import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingsApi from '@/features/dashboard/bookings/api/bookingsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import { BookingDetailsDto } from '@/features/dashboard/bookings/types/BookingDetailsDto.ts';

const useGetBookingDetails = (bookingId: string | undefined) =>
  useQuery(getBookingDetailsQueryOptions(bookingId));

export const getBookingDetailsQueryOptions = (
  bookingId: string | undefined,
): UseQueryOptions<BookingDetailsDto> => ({
  queryKey: bookingsApiQueryKeys.byId(bookingId ?? ''),
  queryFn: () => bookingsApi.getDetails(bookingId!),
  enabled: !!bookingId,
  staleTime: 1000 * 60,
});

export default useGetBookingDetails;
